import ERRCODES from '@/utils/error-codes'
export default {
  methods: {
    validate (row) {
      const outErrors = []
      const name = row.name

      const documentNameMinLen = 10
      const documentNameMaxLen = 1000

      if (name.length <= documentNameMinLen) {
        outErrors.push(ERRCODES.document.documentNameMinLen)
      } else if (name.length > documentNameMaxLen) {
        outErrors.push(ERRCODES.document.documentNameMaxLen)
      }

      return outErrors
    },
    validateFile (file) {
      const outErrors = []

      const fileExt = file.type.split('.').pop()
      if (fileExt === 'pdf') {
        outErrors.push(ERRCODES.document.fileExt)
      }
      if (file.size === 0) {
        outErrors.push(ERRCODES.document.fileSize)
      }

      return outErrors
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documents/Validate.mixin.js